import { render, staticRenderFns } from "./StaffBasicProperty.vue?vue&type=template&id=3db13d2a&scoped=true&"
import script from "./StaffBasicProperty.vue?vue&type=script&lang=ts&"
export * from "./StaffBasicProperty.vue?vue&type=script&lang=ts&"
import style0 from "./StaffBasicProperty.vue?vue&type=style&index=0&id=3db13d2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db13d2a",
  null
  
)

export default component.exports